import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { TimelineMax } from 'gsap/all'
import CSSPlugin from 'gsap/CSSPlugin'

const C = CSSPlugin // eslint-disable-line no-unused-vars

const Container = styled.div`
  width: 100%;
  height: 100%;
`

export default class RotateImage extends Component {
  static contextTypes = {
    scrollmagic: PropTypes.any,
  }

  constructor(props) {
    super(props)

    this.item = null
    this.animation = new TimelineMax({ paused: true })
  }

  componentDidMount() {
    const { scrollMagic, rotation } = this.props
    const { Scene } = scrollMagic

    this.animation
      .to(this.image, 0.5, {
        ease: 'Power0.easeNone',
        rotation: rotation || '-8',
        transformOrigin: 'center center',
      })
      .to(this.image, 0.5, {
        ease: 'Power0.easeNone',
        y: '-=2'
      })

    this.scene = new Scene({
      triggerElement: this.item,
      offset: 100,
      triggerHook: 0.8
    })
    this.scene.on('enter', () => {
      this.animation.play()
    })
    this.scene.addTo(this.context.scrollmagic)
  }

  render() {
    const { image } = this.props
    return (
      <Container ref={c => { this.item = c }}>
        <div
          ref={c => { this.image = c }}
        >
          <Img fluid={image} />
        </div>
      </Container>
    )
  }
}
